<template>
  <div>
    <a-drawer
      :zIndex="2000"
      class="create-device"
      wrapClassName="drawer"
      placement="right"
      :title="$t('mygwf.components.Card.create_device')"
      :visible="visible"
      @close="$emit('close', changes)"
    >
      <p class="text-gray-400">{{ $t('mygwf.components.Card.create_device.subtitle') }}</p>
      <div class="mt-10 p-3">
        <form @submit.prevent="createDevice()">
          <FormError :errors="errors" class="text-sm" />
          <div class="flex justify-between flex-col mb-8 pb-6 border-b space-y-4">
            <base-input v-model.trim="newDevice.serial" label="serial" type="text" />
            <base-input v-model="keyTypes.label" label="device_type" disabled type="text" />
            <fieldset>
              <label class="mb-1 block">{{ $t(`mygwf.components.Label.company_name`) }}</label>
              <SingleSelect
                :required="true"
                :options="$store.getters['companies/list']"
                class="mt-2 p-4 text-sm border"
                v-model="newDevice.company"
                clearable
              />
            </fieldset>
          </div>
          <div class="flex justify-end space-x-5">
            <base-button
              type="close"
              context="secondary"
              :disabled="isSavingDevice"
              class="w-1/4"
              @click="$emit('close')"
              action="close"
            />
            <base-button
              type="submit"
              :loading="isSavingDevice"
              :disabled="newDevice.serial === ''"
              class="w-1/4"
              action="submit"
            />
          </div>
        </form>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import Drawer from 'ant-design-vue/lib/drawer'
import 'ant-design-vue/lib/drawer/style/index.css'
import {BaseCard, BaseSelect, BaseButton, BaseInput} from '@/components/base'
import FormError from '@/components/shared/FormError.vue'
import SingleSelect from '@/components/shared/SingleSelect.vue'

export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      newDevice: {serial: ''},
      isSavingDevice: false,
      changes: false,
    }
  },
  computed: {
    keyTypes() {
      return this.$store.getters['devices/moduleTypes'].filter(type => type.label === 'AFM')[0]
    },
    deviceCompany: {
      get() {
        return this.newDevice.company
      },
      set(value) {
        return this.$store.getters['companies/list'].filter(c => c.id === value)[0]
      },
    },
  },
  methods: {
    createDevice() {
      this.isSavingDevice = true
      this.$store
        .dispatch('devices/create', {
          serial_number: this.newDevice.serial,
          type: 'afm',
          company: this.deviceCompany,
        })
        .then(() => {
          this.newDevice = {}
          this.$store.dispatch('app/notification', {type: 'success', group: 'app', text: `created`})
          setTimeout(() => {
            this.$emit('close', this.changes)
          }, 100)
        })
        .catch(errors => {
          this.errors = errors
        })
        .finally(() => {
          this.isSavingDevice = false
          this.changes = true
          //
          //
          //
        })
    },
  },
  components: {
    'a-drawer': Drawer,
    BaseCard,
    BaseButton,
    BaseInput,
    BaseSelect,
    FormError,
    SingleSelect,
  },
}
</script>
